import Link from "next/link";

const ContactConsentDisclaimer = ({ ctaText }: { ctaText: string }) => {
    return (
        <div className="pb-4 text-xs font-medium leading-4 text-content-secondary">
            By clicking &quot;{ctaText}&quot; you confirm your information is accurate and acknowledge that Spot may send you commercial electronic messages about your quote for up
            to 6 months. Consent is not required to purchase pet insurance. Your personal information will not be shared with third parties. Your information is collected and used
            in accordance with our{" "}
            <Link href="https://spotpetinsurance.ca/privacy" target="_blank" rel="noopener noreferrer" className="underline">
                Privacy Policy
            </Link>{" "}
            and{" "}
            <Link href="https://spotpetinsurance.ca/privacy#texting-terms-CA" target="_blank" rel="noopener noreferrer" className="underline">
                Texting Terms.
            </Link>{" "}
        </div>
    );
};

export default ContactConsentDisclaimer;
